import { Field } from "formik";
import { registerWidget } from "./registry";

export const ChoiceFormField = (config: any, formikParams: any) => {
  const extraProps = config ?? {};
  if (formikParams.handleChange != null)
    extraProps["onChange"] = formikParams.handleChange;
  if (formikParams.readOnly != null)
    extraProps["readOnly"] = formikParams.readOnly;
  return (
    <div style={{ margin: "10px 0px" }}>
      <Field
        {...extraProps}
        key={config.key ?? config.name}
        name={config.name}
        type={"choice"}
        className="btn-group"
        role="group"
        ariaLabel="Basic radio toggle button group"
        id={config.name}
        as="div">
        {config.options.map((x: any, i: number) => (<>
          <input className="btn-check" id={`${config.name}-btnradio${i}`} type="radio" name={config.name} value={x.key ?? x.text} />
          <label className="btn btn-outline-primary" htmlFor={`${config.name}-btnradio${i}`}>{x.text ?? x.key}</label><br /></>))}
      </Field>
    </div>
  );
};

registerWidget("choice", ChoiceFormField);
